import { render, staticRenderFns } from "./ed-header.vue?vue&type=template&id=71bf5aef&scoped=true&"
import script from "./ed-header.ts?vue&type=script&lang=ts&"
export * from "./ed-header.ts?vue&type=script&lang=ts&"
import style0 from "./ed-header.scss?vue&type=style&index=0&id=71bf5aef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf5aef",
  null
  
)

export default component.exports